import { useRef, useState, useEffect, useMemo } from 'react'
import _ from 'lodash'
import { collection, getDocs, query, where, documentId } from 'firebase/firestore'
import { db } from 'data/firebase'

export function useProfilesMap(userIds = []) {
  const cacheRef = useRef({})
  const [profilesById, setProfilesById] = useState({})

  const userIdsFiltered = useMemo(() => userIds.filter(Boolean), [userIds])

  const missingIds = useMemo(() => userIdsFiltered.filter(id => !cacheRef.current[id]), [userIdsFiltered])

  const missingKey = useMemo(() => missingIds.join(','), [missingIds])

  useEffect(() => {
    let mounted = true

    if (!missingKey) return

    const idsToFetch = missingKey.split(',')

    const chunks = _.chunk(idsToFetch, 10)
    Promise.all(chunks.map(chunk => getDocs(query(collection(db, 'profiles'), where(documentId(), 'in', chunk)))))
      .then(snaps => {
        if (!mounted) return
        const newEntries = {}
        snaps.forEach(snap =>
          snap.docs.forEach(d => {
            newEntries[d.id] = d.data()
          })
        )
        Object.assign(cacheRef.current, newEntries)
        setProfilesById({ ...cacheRef.current })
      })
      .catch(err => {
        console.error('Failed to load profiles', err)
      })

    return () => {
      mounted = false
    }
  }, [missingKey])

  return profilesById
}
